import { TaskNameType } from '@shared/generated';
import type { LocationQueryValue } from 'vue-router';

export const isTaskNameType = (
  value: string | LocationQueryValue[] | LocationQueryValue
): value is TaskNameType => {
  if (Array.isArray(value)) {
    return false;
  }
  return Object.values(TaskNameType).includes(value as TaskNameType);
};
